// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__DLtL3","content":"styles_content__2U7Cf","selectAll":"styles_selectAll__2_Y8E"};